/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Rooster_Les_VerwijderenInputs */

const nl_planning_rooster_les_verwijderen = /** @type {(inputs: Planning_Rooster_Les_VerwijderenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les verwijderen`)
};

/**

* @param {Planning_Rooster_Les_VerwijderenInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_les_verwijderen = /** @type {((inputs?: Planning_Rooster_Les_VerwijderenInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_Les_VerwijderenInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_les_verwijderen(inputs)
});
export { planning_rooster_les_verwijderen as "planning.rooster.les_verwijderen" }